export default "### Only the best\n\nAcross a wide range of makes and models, we source cars of the highest quality.\n";